export default __webpack_public_path__ + "static/bmw-m5-f90-e4f4777caf7fe515e4574a7b7d6b767c.jpg";